module.exports = __webpack_public_path__ + "static/media/Hombre3.27482cd3.svg";